// extracted by mini-css-extract-plugin
module.exports = {"selectionContent":"_fc690f2","srOnly":"_265084e"};